module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "42",
      "height": "45",
      "viewBox": "0 0 42 45",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M40.3343 36.5332C39.2817 34.0398 37.754 31.7749 35.8366 29.8647C33.9249 27.949 31.6604 26.4216 29.168 25.3669C29.1457 25.3558 29.1234 25.3502 29.1011 25.339C32.5776 22.8279 34.8377 18.7374 34.8377 14.1225C34.8377 6.4774 28.6435 0.283203 20.9984 0.283203C13.3533 0.283203 7.15911 6.4774 7.15911 14.1225C7.15911 18.7374 9.41915 22.8278 12.8957 25.3446C12.8734 25.3558 12.8511 25.3613 12.8288 25.3725C10.3288 26.4272 8.08545 27.9395 6.16023 29.8703C4.24454 31.7819 2.71717 34.0464 1.66246 36.5388C0.62631 38.9788 0.0674913 41.5948 0.0162528 44.2453C0.0147634 44.3048 0.02521 44.3641 0.0469773 44.4195C0.0687446 44.475 0.101392 44.5255 0.142996 44.5682C0.1846 44.6108 0.234319 44.6447 0.289223 44.6678C0.344126 44.691 0.403104 44.7029 0.462681 44.7029H3.8109C4.05643 44.7029 4.25174 44.5075 4.25732 44.2676C4.36893 39.9595 6.09884 35.925 9.15688 32.8669C12.3209 29.7029 16.5229 27.9618 20.9984 27.9618C25.4738 27.9618 29.6759 29.7029 32.8399 32.8669C35.8979 35.925 37.6279 39.9595 37.7395 44.2676C37.745 44.5131 37.9404 44.7029 38.1859 44.7029H41.5341C41.5937 44.7029 41.6527 44.691 41.7076 44.6678C41.7625 44.6447 41.8122 44.6108 41.8538 44.5682C41.8954 44.5255 41.928 44.475 41.9498 44.4195C41.9716 44.3641 41.982 44.3048 41.9805 44.2453C41.9247 41.5779 41.3723 38.983 40.3343 36.5332ZM20.9984 23.7207C18.437 23.7207 16.0263 22.7218 14.2127 20.9082C12.3991 19.0946 11.4002 16.6839 11.4002 14.1225C11.4002 11.5611 12.3991 9.15039 14.2127 7.33678C16.0263 5.52316 18.437 4.52428 20.9984 4.52428C23.5598 4.52428 25.9705 5.52316 27.7841 7.33678C29.5977 9.15039 30.5966 11.5611 30.5966 14.1225C30.5966 16.6839 29.5977 19.0946 27.7841 20.9082C25.9705 22.7218 23.5598 23.7207 20.9984 23.7207Z",
      "fill": "black",
      "fill-opacity": "0.45"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f61d437", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f61d437"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/BigUser.vue
// module id = 1506
// module chunks = 159